// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PDF Container */
.pdf-box {
  background: linear-gradient(135deg, #f5f7ff, #eef1ff);
  padding: 12px 15px;
  border-radius: 10px;
  margin-top: 10px;
  border: 1px solid #d6dcff;
}

/* Label */
.pdf-label {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
}


/* Button Style */
.pdf-link-btn {
  display: inline-block;
  padding: 8px 14px;
  background: linear-gradient(135deg, #4a6cf7, #6a8dff);
  color: #fff;
  font-weight: 500;
  border-radius: 6px;
  text-decoration: none;
  transition: all 0.3s ease;
}

/* Hover Effect */
.pdf-link-btn:hover {
  background: linear-gradient(135deg, #3b5bdb, #5c7cfa);
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}`, "",{"version":3,"sources":["webpack://./src/pages/Invoices/InvoiceList.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,qDAAqD;EACrD,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;;AAGA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,qDAAqD;EACrD,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,0CAA0C;AAC5C","sourcesContent":["/* PDF Container */\n.pdf-box {\n  background: linear-gradient(135deg, #f5f7ff, #eef1ff);\n  padding: 12px 15px;\n  border-radius: 10px;\n  margin-top: 10px;\n  border: 1px solid #d6dcff;\n}\n\n/* Label */\n.pdf-label {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: #333;\n}\n\n\n/* Button Style */\n.pdf-link-btn {\n  display: inline-block;\n  padding: 8px 14px;\n  background: linear-gradient(135deg, #4a6cf7, #6a8dff);\n  color: #fff;\n  font-weight: 500;\n  border-radius: 6px;\n  text-decoration: none;\n  transition: all 0.3s ease;\n}\n\n/* Hover Effect */\n.pdf-link-btn:hover {\n  background: linear-gradient(135deg, #3b5bdb, #5c7cfa);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
